export type DeviceType = 'mobile' | 'desktop'

/**
 * Returns 'mobile' or 'desktop' based on the current viewport width. Server-side
 * renders default to 'mobile' since the viewport isn't known yet.
 *
 * Mirrors the logic used by the (legacy) Noodle web-vitals tracking so that
 * dashboards built on top of either signal stay comparable.
 */
export function getDeviceType(): DeviceType {
  if (!process.client) {
    return 'mobile'
  }

  // TODO [FRONT-827] This needs to be shared between modules.
  const breakpoints = [
    '(min-width: 992px)',
    '(min-width: 768px)',
    '(min-width: 480px)',
    '(max-width: 480px)',
  ]

  const matchMedia = (media: string) => window.matchMedia(media).matches
  const breakpoint = breakpoints.length - breakpoints.findIndex(matchMedia) - 1

  return breakpoint < 2 ? 'mobile' : 'desktop'
}
